import {
  MotifButton,
  MotifCard,
  MotifCardBody,
  MotifErrorMessage,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import {
  useGetAccountByIdApiDataQuery,
  useGetSubAccountByIdApiDataQuery,
} from "@/services/configuration/configuration";
import { AccountCreation } from "./AccountCreation";
import { useEffect, useState } from "react";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { EditAccountCreation } from "./editAccountAllInputs";
import { useCase } from "@/features/case/use-case";
import SubAccountTile from "./SubAccountSetUp";
import { SubAccountCreation } from "./SubAccountCreation";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import DeleteAccountSubAccount from "./DeleteAccountSubAccount";
import { useDispatch, useSelector } from "react-redux";
import { havingAddPermission, havingDeletePermission } from "@/utility/common";
import {
  CREATE_BUTTON_VARIANT,
  DELETE_IMG_VARIANT,
  EDIT_IMG_VARIANT,
  getCommonDeleteImg,
  getCommonEditImg,
} from "@/components/Images/CommonImages";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
import { setAccountDetails } from "./AccountSetupSlice";
import SearchInput from "@/components/SearchInput/SearchInput";

export const AccountSetUp = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [subAccShow, setSubAccShow] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [accountId, setEditAccountId] = useState("");
  const [isDiscardVisible, setIsDiscardVisible] = useState(false);
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [editSubAccount, setEditSubAccount] = useState(false);
  const [subAccountErrorMessages, setSubAccountErrorMessages] = useState({
    message: "",
    type: "",
  });
  const [deleteErrorMessage, setDeleteErrorMessage] = useState({
    message: "",
    type: "",
  });
  const [showDeleteSuccessErrorMessage, setShowDeleteSuccessErrorMessage] =
    useState<any>({
      message: "",
      type: "",
      variant: "",
      index: "",
      show: false,
    });
  const [deleteAccountId, setDeleteAccountId] = useState("");
  const caseData = useCase();
  const {
    data: accountList,
    refetch,
    isLoading: accountLoading,
    isError: loadingAccountError,
  } = useGetAccountByIdApiDataQuery(caseData.caseId);
  const permissions = useSelector((state: any) => state.permissions);
  const accountSetupDetails = useSelector((state: any) => state.accountSetup);
  const { Account, SubAccount } = permissions;
  const [selectedStage, setSelectedStage] = useState("");
  const [subAccountSearch, setSubAccountSearch] = useState("");

  const [deleteEntityName, setDeleteEntityName] = useState("");
  const {
    data: subAccountList,
    refetch: refetchSubAccounts,
    isFetching: subAccountsFetching,
    isError: loadingSubAccountError,
  } = useGetSubAccountByIdApiDataQuery(
    { accountId: selectedStage, searchTerm: subAccountSearch },
    { skip: !selectedStage }
  );
  function handleAccountFocus() {
    if (accountSetupDetails?.accountId) {
      let doc = document.getElementById(accountSetupDetails?.accountId);
      doc?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  useEffect(() => {
    setSelectedStage(
      accountSetupDetails?.accountId || accountList?.results[0]?.accountId
    );
  }, [accountList, accountSetupDetails?.accountId]);

  const handleClose = () => {
    setIsDiscardVisible(false);
    setShow(false);
    setEditShow(false);
    setSubAccShow(false);
    setEditSubAccount(false);
  };
  if (accountLoading) {
    return (
      <>
        <br></br>
        <MotifProgressLoader />
      </>
    );
  }
  if (loadingAccountError) {
    return (
      <>
        <br />
        <div
          style={{ width: "100%" }}
          className="motif-row justify-content-center align-items-center"
        >
          <MotifErrorMessage>
            {t("global.globalNotifications.wentWrong")}
          </MotifErrorMessage>
        </div>
      </>
    );
  }
  return (
    <>
      <div
        onClick={() => {
          if (
            accountSetupDetails?.accountId ||
            accountSetupDetails?.subAccountId
          ) {
            dispatch(
              setAccountDetails({
                accountId: "",
                subAccountId: "",
              })
            );
          }
        }}
        className="stage-management-container"
      >
        {/* {window.scrollTo(0, 0)} */}
        {statusMsg && (
          <NotificationGrid
            show={true}
            message={statusMsg}
            type={
              statusMsg === "A Account with the same name already exists."
                ? "error"
                : "success"
            }
            scrollToTop={false}
            onClose={() => setStatusMsg("")}
          />
        )}
        <div
          className="motif-body1-default-regular stage-management-title"
          style={{ marginTop: "15px" }}
        >
          {t("pages.distributions.account.title")}
        </div>
        <div className="stage-management-body">
          <div className="stages-container">
            <div className="stages-header motif-row mar-r-10 mar-l-10">
              <div className="motif-body1-default-bold ">
                {" "}
                {t("pages.distributions.account.accountTitle")}
              </div>
              {havingAddPermission(Account) && (
                <MotifButton
                  onClick={() => setShow(true)}
                  size="small"
                  type="submit"
                  variant={CREATE_BUTTON_VARIANT}
                >
                  {t("pages.distributions.account.createAccount")}
                </MotifButton>
              )}
            </div>
            {deleteErrorMessage.message &&
              deleteErrorMessage.type === "success" && (
                <NotificationGrid
                  show={true}
                  message={deleteErrorMessage.message}
                  type={deleteErrorMessage.type}
                  scrollToTop={false}
                  onClose={() =>
                    setDeleteErrorMessage({ message: "", type: "" })
                  }
                />
              )}

            {accountList && accountList?.results?.length > 0 ? (
              accountList?.results?.map((items: any, index: number) => {
                return (
                  <div
                    className="stage-tile-container"
                    id={items?.accountId}
                    key={items.accountId}
                  >
                    {deleteErrorMessage.message &&
                      items?.accountId === deleteAccountId && (
                        <NotificationGrid
                          show={true}
                          message={deleteErrorMessage.message}
                          type={deleteErrorMessage.type}
                          scrollToTop={false}
                          onClose={() =>
                            setDeleteErrorMessage({ message: "", type: "" })
                          }
                        />
                      )}
                    <MotifCard
                      className={
                        "stage-tile" +
                        (selectedStage === items.accountId ? " active" : "")
                      }
                      style={{ cursor: "pointer" }}
                      orientation="horizontal"
                      variant="card-border"
                      onClick={() => {
                        setSubAccountErrorMessages({ message: "", type: "" });
                        setStatusMsg("");
                        setSelectedStage(items.accountId!);
                        setDeleteErrorMessage({ message: "", type: "" });
                        setSubAccountSearch("");
                      }}
                    >
                      <MotifCardBody className="stage-tile-body motif-row ">
                        <div className="stage-tile-header">
                          <span
                            className="motif-body1-default-bold"
                            onClick={() => {
                              // setEditShow(true);
                              // setEditAccountId(items?.accountId);
                            }}
                          >
                            {items.accountName}
                          </span>
                        </div>
                        <div
                          style={{ display: "flex", flexWrap: "wrap" }}
                          className="stage-tile-actions "
                        >
                          <CommonTooltipWrapper
                            tooltipTitle={t("global.globalActions.edit")}
                          >
                            <MotifButton
                              className="mar-r-10 mar-b-5"
                              onClick={() => {
                                setEditShow(true);
                                setEditAccountId(items?.accountId);
                                setShowDeleteSuccessErrorMessage({
                                  message: "",
                                  type: "",
                                  variant: "",
                                  index: "",
                                  show: false,
                                });
                              }}
                              type="button"
                              variant={EDIT_IMG_VARIANT}
                            >
                              {getCommonEditImg()}
                            </MotifButton>
                          </CommonTooltipWrapper>

                          {havingDeletePermission(Account) && (
                            <CommonTooltipWrapper
                              tooltipTitle={t("global.globalActions.delete")}
                            >
                              <MotifButton
                                type="button"
                                variant={DELETE_IMG_VARIANT}
                                onClick={() => {
                                  setShowDeleteAccount(true);
                                  setDeleteAccountId(items?.accountId);
                                  setDeleteEntityName(items?.accountName);
                                  setDeleteErrorMessage({
                                    message: "",
                                    type: "",
                                  });
                                  setShowDeleteSuccessErrorMessage({
                                    message: "",
                                    type: "",
                                    variant: "",
                                    index: index - 1,
                                    show: false,
                                  });
                                  setStatusMsg("");
                                }}
                              >
                                {getCommonDeleteImg()}{" "}
                              </MotifButton>
                            </CommonTooltipWrapper>
                          )}
                        </div>
                      </MotifCardBody>
                    </MotifCard>
                    {showDeleteSuccessErrorMessage.show &&
                      showDeleteSuccessErrorMessage.index === index &&
                      showDeleteSuccessErrorMessage.index >= 0 &&
                      showDeleteSuccessErrorMessage.variant === "account" && (
                        <>
                          <br></br>{" "}
                          <NotificationGrid
                            show={showDeleteSuccessErrorMessage.show}
                            message={showDeleteSuccessErrorMessage.message}
                            type={showDeleteSuccessErrorMessage.type}
                            scrollToTop={false}
                            onClose={() =>
                              setShowDeleteSuccessErrorMessage({
                                message: "",
                                type: "",
                                variant: "",
                                index: "",
                                show: false,
                              })
                            }
                          />
                        </>
                      )}
                  </div>
                );
              })
            ) : (
              <div className="status-body">
                <div className="motif-row justify-content-center align-items-center">
                  {t("global.globalNotifications.noRecords")}
                </div>
              </div>
            )}
          </div>
          <div className="status-container">
            <div className="status-header motif-row mar-r-10 mar-l-10">
              <div className="motif-body1-default-bold">
                {" "}
                {t("pages.distributions.account.subAccountTitle")}
              </div>
              {havingAddPermission(SubAccount) &&
                accountList.results.length > 0 && (
                  <MotifButton
                    onClick={() => {
                      setSubAccShow(true);
                      setShowDeleteSuccessErrorMessage({
                        message: "",
                        type: "",
                        variant: "",
                        index: "",
                        show: false,
                      });
                    }}
                    size="small"
                    type="submit"
                    variant={CREATE_BUTTON_VARIANT}
                  >
                    {t("pages.distributions.account.createSubAccount")}
                  </MotifButton>
                )}
            </div>
            {
              <div className="motif-row justify-content-center mar-t-20">
                <SearchInput
                  className="motif-col-lg-11"
                  placeholder={t(
                    "pages.distributions.account.subAccountPlaceholder"
                  )}
                  value={subAccountSearch}
                  onChange={(e) => {
                    if (
                      accountSetupDetails?.accountId ||
                      accountSetupDetails?.subAccountId
                    ) {
                      dispatch(
                        setAccountDetails({
                          accountId: "",
                          subAccountId: "",
                        })
                      );
                    }
                    setSubAccountSearch(e.target.value);
                  }}
                  onClear={() => setSubAccountSearch("")}
                />
              </div>
            }
            <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 50px)" }}>
              <SubAccountTile
                SubAccount={SubAccount}
                selectedStage={selectedStage}
                subAccountList={subAccountList?.results}
                setStatusMsg={setStatusMsg}
                refetchSubAccounts={refetchSubAccounts}
                setIsDiscardVisible={setIsDiscardVisible}
                setEditSubAccount={setEditSubAccount}
                editSubAccount={editSubAccount}
                subAccountsFetching={subAccountsFetching}
                loadingSubAccountError={loadingSubAccountError}
                subAccountErrorMessages={subAccountErrorMessages}
                setSubAccountErrorMessages={setSubAccountErrorMessages}
                setShowDeleteSuccessErrorMessage={
                  setShowDeleteSuccessErrorMessage
                }
                showDeleteSuccessErrorMessage={showDeleteSuccessErrorMessage}
              />
            </div>
          </div>
        </div>

        {show && (
          <AccountCreation
            show={show}
            setShow={setShow}
            refetch={refetch}
            setStatusMsg={setStatusMsg}
            setIsDiscardVisible={setIsDiscardVisible}
            setSubAccountErrorMessages={setSubAccountErrorMessages}
          />
        )}
        {editShow && (
          <EditAccountCreation
            Account={Account}
            editShow={editShow}
            setEditShow={setEditShow}
            refetch={refetch}
            accountId={accountId}
            setStatusMsg={setStatusMsg}
            setIsDiscardVisible={setIsDiscardVisible}
            setSubAccountErrorMessages={setSubAccountErrorMessages}
          />
        )}
        {subAccShow && (
          <SubAccountCreation
            subAccShow={subAccShow}
            setSubAccShow={setSubAccShow}
            refetchSubAccounts={refetchSubAccounts}
            setStatusMsg={setStatusMsg}
            selectedStage={selectedStage}
            setIsDiscardVisible={setIsDiscardVisible}
            setSubAccountErrorMessages={setSubAccountErrorMessages}
          />
        )}
        <DeleteAccountSubAccount
          show={showDeleteAccount}
          setShow={setShowDeleteAccount}
          id={deleteAccountId}
          isAccount={true}
          setDeleteErrorMessage={setDeleteErrorMessage}
          refetch={refetch}
          deleteEntityName={deleteEntityName}
          setStatusMsg={setStatusMsg}
          setShowDeleteSuccessErrorMessage={setShowDeleteSuccessErrorMessage}
          showDeleteSuccessErrorMessage={showDeleteSuccessErrorMessage}
          setDeleteAccountId={setDeleteAccountId}
        />
        <ConfirmationModal
          isVisible={isDiscardVisible}
          setIsVisible={setIsDiscardVisible}
          cancelBtnApproveHandler={handleClose}
          cancelBtnRejectHandler={() => setIsDiscardVisible(false)}
        />
      </div>
      {handleAccountFocus()}
    </>
  );
};
